import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './CircularProgressValue.module.scss';

export default function CircularProgressValue(props) {
  const { value, icon, title, invert, suffix } = props;

  return (
    <div
      className={cn(styles.container, props.passed ? styles.passed : styles.failed, invert ? styles.invert : '')}
      data-testid={props['data-testid'] || 'container'}
    >
      {title && <h4 data-testid="title">{title}</h4>}

      <div className={styles.progressBar} style={{ '--value': value }}>
        {icon && (
          <div className={styles.icon} data-testid="icon">
            {icon}
          </div>
        )}
      </div>

      <label data-testid="label" suffix={suffix ? suffix : ''}>
        {value}
      </label>
    </div>
  );
}

CircularProgressValue.defaultProps = {
  passed: true,
  invert: false,
};

CircularProgressValue.propTypes = {
  title: PropTypes.string,
  value: PropTypes.number.isRequired,
  icon: PropTypes.node,
  passed: PropTypes.bool.isRequired,
  invert: PropTypes.bool,
  suffix: PropTypes.string,
};
